"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _actions = require("settings-ui-sdk/QuoteApproval/actions");

var initialState = false;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _actions.CreateWorkflowsActionTypes.SUCCESS:
      return true;

    case _actions.FetchWorkflowsExistenceActionTypes.SUCCESS:
      return action.payload.data.quoteApprovalWorkflowsExist;

    default:
      return state;
  }
};

exports.default = _default;
module.exports = exports.default;